const emailRegex = /^[\S_\+-]+@[\S_\+-]+\.[\S_\+-]+$/;

export const validateEmail = (email) => emailRegex.test(email);
